// Button primitive. Three kinds (ghost/primary/quiet) + optional danger.

export function Button({ kind = 'ghost', onClick, icon, children, danger }) {
  const base = {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    padding: '7px 12px',
    borderRadius: 8,
    fontFamily: 'Inter, -apple-system, sans-serif',
    fontSize: 12.5,
    fontWeight: 500,
    letterSpacing: '-0.005em',
    cursor: 'pointer',
    border: '1px solid transparent',
    background: 'transparent',
    color: '#3E4148',
    transition: 'background 120ms, border-color 120ms, color 120ms',
  };
  const variants = {
    primary: { background: '#0F1419', color: '#fff', borderColor: '#0F1419' },
    ghost:   { background: '#FFF', color: '#3E4148', borderColor: '#E8E6E0' },
    quiet:   { background: 'transparent', color: '#6E7278', borderColor: 'transparent' },
  };
  const dangerS = danger ? { color: '#A3392A', borderColor: '#EDD9D5' } : {};
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ ...base, ...variants[kind], ...dangerS }}
      onMouseEnter={e => { e.currentTarget.style.background = kind === 'primary' ? '#1C242B' : '#F6F4EE'; }}
      onMouseLeave={e => { e.currentTarget.style.background = variants[kind].background; }}
    >
      {icon}
      {children}
    </button>
  );
}
